import Content, { ContentNS } from "content/content";
import ChecklistItem from "models/checklist/checklist-item/checklist-item";
import ChecklistItemStatus from "models/checklist/checklist-item/checklist-item-status";

const useCardErrorMessage = (item: ChecklistItem): string | null => {
  const text = (s: string, args?: object) =>
    Content.shared.t(s, { ns: ContentNS.checklist, ...args });

  if (item.status === ChecklistItemStatus.VerificationRequired) {
    return text("issues.verification-required");
  }

  return null;
};

export default useCardErrorMessage;
